import type { ComponentProps } from 'react';

import { RarityCard } from '@/shared/components/ui/rarityCard';
import { Separator } from '@/shared/components/ui/separator';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { cn } from '@/shared/utils/cn';

interface ProfileSkeletonProps extends ComponentProps<'div'> {}

export const ProfileSkeleton = ({
  className,
  ...rest
}: ProfileSkeletonProps) => {
  return (
    <RarityCard.Outer
      {...rest}
      rarity="COMMON"
      className={cn('relative h-full w-full', className)}
    >
      <RarityCard.Inner className="flex h-full w-full flex-col gap-0 overflow-hidden">
        <div className="bg-cold-950 no-scrollbar flex h-full flex-col overflow-y-auto">
          {/* Header Section */}
          <div className="flex flex-col gap-1 p-4">
            <div className="relative flex items-start justify-center">
              <Skeleton className="size-12 rounded-full" />
            </div>
            <div className="flex flex-col items-center gap-1.5">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-4 w-48" />
              <Skeleton className="h-10 w-2/3" />
            </div>
            <div className="mt-2 flex items-center justify-center gap-2">
              <Skeleton className="h-5 w-16" />
              <Skeleton className="h-5 w-16" />
            </div>
          </div>

          <Separator />

          {/* Gameplay Section */}
          <div className="flex flex-col gap-2 p-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-4 w-16" />
            </div>
            <Skeleton className="h-20 w-full rounded-lg" />
            <div className="flex gap-2">
              <Skeleton className="h-16 flex-1 rounded-lg" />
              <Skeleton className="h-16 flex-1 rounded-lg" />
              <Skeleton className="h-16 flex-1 rounded-lg" />
            </div>
            <div className="grid grid-cols-2 gap-2">
              <Skeleton className="h-12 rounded-lg" />
              <Skeleton className="h-12 rounded-lg" />
              <Skeleton className="h-12 rounded-lg" />
              <Skeleton className="h-12 rounded-lg" />
            </div>
            <Skeleton className="h-4 w-32" />
          </div>

          <Separator />

          {/* Vibe Section */}
          <div className="flex flex-col gap-2 p-4">
            <div className="flex items-center justify-between">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-4 w-16" />
            </div>
            <Skeleton className="h-16 w-full rounded-lg" />
            <Skeleton className="h-16 w-full rounded-lg" />
            <Skeleton className="h-16 w-full rounded-lg" />
            <Skeleton className="h-12 w-full rounded-lg" />
          </div>
        </div>

        {/* Bottom Action Button */}
        <div className="bg-cold-950 z-1 flex items-center gap-1 rounded-b-2xl px-2 pt-4 pb-2">
          <Skeleton className="h-10 flex-1 rounded-lg" />
        </div>
      </RarityCard.Inner>
    </RarityCard.Outer>
  );
};
